import axios from 'axios';
import _ from 'lodash';
import config from '../config';

export default axios.create({
  baseURL: _.get(config, 'apiBaseUrl'),
  responseType: 'json',
});
